export const planStateIds = {
  undefined: 0,
  created: 1,
  filling: 2,
  sentToNce: 3,
  transferredToBranch: 4,
  inProgressNce: 5,
  editedByExecutor: 6,
  onSlaApproval: 7,
  sentForApproval: 8,
  revision: 9,
  returnedForCorrection: 10,
  agreed: 11,
  slaApproved: 12,
  onApproval: 13,
  transferredToDepartmentHead: 14,
  approved: 15,
  final: 16,
  declined: 17,
  rejected: 18,
};

/** Статусы активного BPMN PlanDocument */
export const planDocumentBpmnStateIds = [
  planStateIds.created,
  planStateIds.inProgressNce,
  planStateIds.onSlaApproval,
  planStateIds.onApproval,
  planStateIds.approved,
];

export const planStateLabels = {
  [planStateIds.undefined]: "Undefined",
  [planStateIds.created]: "Создан",
  [planStateIds.filling]: "Заполняется",
  [planStateIds.sentToNce]: "Отправлен в НЦЭ",
  [planStateIds.transferredToBranch]: "Передан на обработку филиалу НЦЭ",
  [planStateIds.inProgressNce]: "В работе НЦЭ",
  [planStateIds.editedByExecutor]: "Редактируется исполнителем",
  [planStateIds.onSlaApproval]: "На согласовании СЛА",
  [planStateIds.sentForApproval]: "Отправлен на согласование",
  [planStateIds.revision]: "На доработке",
  [planStateIds.returnedForCorrection]: "Возвращён на исправление",
  [planStateIds.agreed]: "Согласован",
  [planStateIds.slaApproved]: "Одобрен СЛА",
  [planStateIds.onApproval]: "На утверждении",
  [planStateIds.transferredToDepartmentHead]: "Передан руководителю Департамента",
  [planStateIds.approved]: "Утвержден",
  [planStateIds.final]: "Финальный статус",
  [planStateIds.declined]: "Отклонён",
  [planStateIds.rejected]: "Отказ на любом этапе",
};

export const getPlanStateLabel = (stateId, fallback = "—") => {
  const id = Number(stateId);
  if (!Number.isFinite(id)) return fallback;
  return planStateLabels[id] || fallback;
};

